var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5626 6.71875C16.5626 6.34585 16.4144 5.9881 16.1507 5.7244C15.887 5.4607 15.5293 5.3125 15.1564 5.3125H4.83081C4.45791 5.3125 4.10016 5.4607 3.83646 5.7244C3.57276 5.9881 3.42456 6.34585 3.42456 6.71875V13.2813C3.42456 13.6542 3.57276 14.0119 3.83646 14.2756C4.10016 14.5393 4.45791 14.6875 4.83081 14.6875H15.1564C15.5293 14.6875 15.887 14.5393 16.1507 14.2756C16.4144 14.0119 16.5626 13.6542 16.5626 13.2813V6.71875ZM15.6251 6.71875V13.2813C15.6251 13.4056 15.5758 13.5248 15.4879 13.6128C15.4 13.7007 15.2807 13.75 15.1564 13.75H4.83081C4.70646 13.75 4.58721 13.7007 4.49931 13.6128C4.41141 13.5248 4.36206 13.4056 4.36206 13.2813V6.71875C4.36206 6.5944 4.41141 6.47515 4.49931 6.38725C4.58721 6.29935 4.70646 6.25 4.83081 6.25H15.1564C15.2807 6.25 15.4 6.29935 15.4879 6.38725C15.5758 6.47515 15.6251 6.5944 15.6251 6.71875Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28547 6.35445C4.28547 6.35445 7.59552 9.5205 9.02817 10.8908C9.57177 11.4108 10.4286 11.4108 10.9722 10.8908C12.4048 9.5205 15.7149 6.35445 15.7149 6.35445C15.9018 6.17565 15.9084 5.87865 15.7296 5.6916C15.5508 5.5047 15.2538 5.4981 15.0667 5.6769C15.0667 5.6769 11.7567 8.8431 10.3242 10.2134C10.143 10.3868 9.85737 10.3868 9.67617 10.2134L4.93362 5.6769C4.74657 5.4981 4.44957 5.5047 4.27077 5.6916C4.09197 5.87865 4.09857 6.17565 4.28547 6.35445Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78532 9.46756L3.94862 13.5062C3.77042 13.6937 3.77807 13.9907 3.96572 14.1689C4.15322 14.3471 4.45022 14.3394 4.62842 14.1519L8.46512 10.1132C8.64332 9.92566 8.63567 9.62866 8.44802 9.45046C8.26052 9.27226 7.96352 9.27991 7.78532 9.46756Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3009 10.1132L15.2852 14.3073C15.4634 14.4948 15.7604 14.5025 15.9479 14.3243C16.1356 14.1461 16.1432 13.8492 15.965 13.6616L11.9806 9.46756C11.8024 9.27991 11.5055 9.27226 11.3179 9.45046C11.1304 9.62866 11.1227 9.92566 11.3009 10.1132Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.12f199bd11824dd6484c720dbeff0a78.svg";
export { ForwardRef as ReactComponent };